import { defineComponent, markRaw } from 'vue';
import FrozenBanner from '@/client/components/replay/FrozenBanner.vue';
// The fixed stack that the frozen banner and the rewind vote banner (which teleports into it) sit in, and the spacer
// in the page's flow that keeps the page from sliding under them.
export default defineComponent({
    name: 'BannerStack',
    components: { FrozenBanner },
    props: {
        frozen: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return { height: 0, observer: undefined };
    },
    methods: {
        resize(entries) {
            this.height = Math.ceil(entries[entries.length - 1].contentRect.height);
        },
    },
    mounted() {
        if (typeof ResizeObserver === 'undefined') {
            return;
        }
        this.observer = markRaw(new ResizeObserver((entries) => this.resize(entries)));
        this.observer.observe(this.$refs.stack);
    },
    unmounted() {
        this.observer?.disconnect();
    },
});
